import { schema } from "normalizr";

export const UserSchema = new schema.Entity(
  "users",
  {},
  {
    idAttribute: "objectId",
  }
);
